import { render } from "./companyview.vue?vue&type=template&id=0c6c8932&scoped=true"
import script from "./companyview.vue?vue&type=script&lang=js"
export * from "./companyview.vue?vue&type=script&lang=js"

import "./companyview.vue?vue&type=style&index=0&id=0c6c8932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6c8932"]])

export default __exports__